import { Spacing } from '@persona-id/design-tokens';
import { XIcon } from '@persona-id/design-tokens/icons';
import { FC } from 'react';
import styled from 'styled-components';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { VersionMetadata } from 'dashboard/components-lib/VersionsSection/utils';
import { VersionsList } from 'dashboard/components-lib/VersionsSection/VersionsList';
import Button from 'design-system/components/Button';
import { Label } from 'design-system/components/Text';
import { Hairline } from 'design-system/variables/effect';

const VerticalSection = styled.nav`
  background-color: ${({ theme }) => theme.color.background.primary};
  display: flex;
  width: 600px;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  border-left: 1px solid ${({ theme }) => theme.color.border.primary};
`;

const HeaderContainer = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${Spacing[3]} ${Spacing[5]};
  margin-bottom: 1px;
  box-shadow: ${Hairline.Bottom};
`;

const BottomRow = styled.div`
  padding: ${Spacing[2]};
  box-shadow: ${Hairline.Top};
`;

export interface VersionsSectionProps {
  versions: VersionMetadata[];
  hide: () => void;
  currentVersionId: string;
  isFormPristine: boolean;
  formName: string;
  isLoading?: boolean;
  handleAddLocalDraftVersion: () => void;
  handleDiscardDraft: () => Promise<void>;
  handleSelectVersion: (versionId: string) => void;
  setDescription?: (description: string) => void;
}

export const VersionsSection: FC<VersionsSectionProps> = ({
  versions,
  hide,
  currentVersionId,
  isFormPristine,
  formName,
  isLoading = false,
  handleAddLocalDraftVersion,
  handleDiscardDraft,
  handleSelectVersion,
  setDescription,
}) => {
  return (
    <VerticalSection aria-label='Version History'>
      <HeaderContainer>
        <Label size='lg' weight='bold'>
          Version History
        </Label>
        <Button
          width='icon'
          onClick={hide}
          id='version-sections__close'
          aria-label='Close'
          variant='inverse'
        >
          <XIcon />
        </Button>
      </HeaderContainer>
      {isLoading ? (
        <LoadingIndicator fullscreen />
      ) : (
        <VersionsList
          versions={versions}
          currentVersionId={currentVersionId}
          isFormPristine={isFormPristine}
          formName={formName}
          handleAddLocalDraftVersion={handleAddLocalDraftVersion}
          handleDiscardDraft={handleDiscardDraft}
          handleSelectVersion={handleSelectVersion}
          setDescription={setDescription}
        />
      )}

      <BottomRow>
        <Button onClick={hide} width='auto' variant='basic' id='versions-section__close-button'>
          Close
        </Button>
      </BottomRow>
    </VerticalSection>
  );
};
